import React from 'react';
import connectToI18n from 'modules/i18n/connectToI18n';
import PropTypes from 'prop-types';
import { getLocaleShortform, getLocaleByCode } from 'modules/utils/locales';
import { Button, Wrapper, Grid } from 'components/ui';
import PageHeader from 'components/PageHeader.jsx';
import {
    AddressInputGroup,
    TextInputGroup,
    CheckboxGroup,
    FormSelectGroup,
} from 'components/ui/form';

export class ValidateSCU extends React.Component {
    static propTypes = {
        trans: PropTypes.func.isRequired,
        type: PropTypes.string.isRequired,
        i18n: PropTypes.string.isRequired,
        isAccepted: PropTypes.bool,
        formData: PropTypes.object.isRequired,
        edit: PropTypes.func.isRequired,
        submit: PropTypes.func.isRequired,
        clientErrors: PropTypes.object.isRequired,
        serverErrors: PropTypes.object.isRequired,
        showErrors: PropTypes.bool.isRequired,
    };

    onChange = (name, value) => {
        this.props.edit(name, value);
    };

    onSubmit = e => {
        e.preventDefault();
        this.props.submit();
    };

    getTexts = () => {
        const trans = this.props.trans;
        switch (this.props.type) {
            case 'host':
                return {
                    text: trans('user.becomeLeaderText'),
                    action: trans('user.becomeLeader'),
                };
            case 'producer':
                return {
                    text: trans('user.becomeProviderText'),
                    action: trans('user.becomeProvider'),
                };
            default:
                return {
                    text: trans('user.validateSCUText'),
                    action: trans('user.validateSCU'),
                };
        }
    };

    render() {
        const { trans, isAccepted, formData, showErrors, clientErrors, serverErrors } = this.props;
        const localeCode = getLocaleShortform(getLocaleByCode(this.props.i18n));
        const url = `/${localeCode}/p/terms`;
        const { text, action } = this.getTexts();

        return (
            <Wrapper>
                <PageHeader title={action} />
                <Grid xs=".10" sm="...6">
                    <div className="validateSCU">
                        <p>{text}</p>
                        <div className="paymentProfileCompletion-formRow">
                            <TextInputGroup
                                className="paymentProfileCompletion-formCell"
                                name="phone"
                                inputVariant="inverse"
                                label={trans('global.phoneNumber')}
                                onChange={this.onChange}
                                value={formData.phone}
                                showErrors={showErrors}
                                clientErrors={clientErrors.phone}
                                serverErrors={serverErrors.phone}
                            />
                        </div>
                        <AddressInputGroup
                            cityName="cityId"
                            initialCountry={formData.country?.id}
                            initialZip={formData.zipCode}
                            initialCity={formData.cityId}
                            onChange={this.onChange}
                        >
                            {({
                                countries,
                                country,
                                zip,
                                cities,
                                onZipChange,
                                areCitiesReady,
                                onCountryChange,
                            }) => (
                                <React.Fragment>
                                    <FormSelectGroup
                                        name="country"
                                        isDisabled={countries.length === 0}
                                        isRequired
                                        inputVariant="productIdentity"
                                        label={trans('address.country')}
                                        options={countries}
                                        value={country}
                                        onChange={onCountryChange}
                                        emptyOption={trans('address.countryChoose')}
                                    />
                                    <TextInputGroup
                                        className="paymentProfileCompletion-formCell"
                                        name="street"
                                        label={trans('address.numberWay')}
                                        value={formData.street}
                                        onChange={this.onChange}
                                        inputVariant="inverse"
                                        showErrors={showErrors}
                                        clientErrors={clientErrors.street}
                                        serverErrors={
                                            serverErrors.address && serverErrors.address.street
                                        }
                                    />
                                    <div className="paymentProfileCompletion-formCell u-flexible-row">
                                        <TextInputGroup
                                            className="paymentProfileCompletion-zipCode"
                                            name="zipCode"
                                            inputVariant="inverse"
                                            label={trans('address.zip')}
                                            value={zip}
                                            onChange={onZipChange}
                                            showErrors={showErrors}
                                            clientErrors={clientErrors.zipCode}
                                            serverErrors={serverErrors.zipCode}
                                        />
                                        <FormSelectGroup
                                            className="paymentProfileCompletion-city"
                                            name="cityId"
                                            clientErrors={clientErrors.cityId}
                                            serverErrors={
                                                serverErrors.address && serverErrors.address.city
                                            }
                                            showErrors={showErrors}
                                            isDisabled={!areCitiesReady}
                                            emptyOption={
                                                cities.length !== 0
                                                    ? trans('address.cityDefault')
                                                    : trans('user.city.void')
                                            }
                                            inputVariant="inverse"
                                            label={trans('address.city')}
                                            options={cities}
                                            value={formData.cityId}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </React.Fragment>
                            )}
                        </AddressInputGroup>
                        <CheckboxGroup
                            id="hasAcceptedSCU"
                            isChecked={isAccepted}
                            onChange={this.onChange}
                        >
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: trans('user.scu', { '%url%': url }),
                                }}
                            />
                        </CheckboxGroup>
                        <Button
                            variant="primary"
                            block
                            onClick={this.onSubmit}
                            disabled={!formData.hasAcceptedSCU}
                        >
                            {action}
                        </Button>
                    </div>
                </Grid>
            </Wrapper>
        );
    }
}

export default connectToI18n(ValidateSCU);
